import { useState } from 'react'
import Header from '../../../../customs/Header'
import CountryContent from './CountryContent';
import SettingsModal from '../Modal/settingsCustomModal';
import CreateCountry from './CreateCountry';

export default function Main() {
  const [createCountry, setCreateCountry] = useState(false);

  const handleOpenCreateCountry = () => setCreateCountry(true);
  const handleCloseCreateCountry = () => setCreateCountry(false);

  return (
    <section>
      <Header props={
      { 
        firstName: 'All', 
        secondName: 'Country', 
        buttonText: 'Create Country', 
      }}
      handleOpen={handleOpenCreateCountry}
    />

    <CountryContent />
    
    <SettingsModal 
      open={createCountry}
      cancel={handleCloseCreateCountry}
      maxWidth='480px'
      header={'Create Country'}
      showrightIcon={false}
      content={<CreateCountry handleClose={handleCloseCreateCountry}/>}
    />
    </section>
    
  )
}

